import { nextArrow, prevArrow, options } from "@/global/slick-options";

jQuery( '#serviceFeatures' ).slick( {
    ...options,
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    rows: 0,
    prevArrow,
    nextArrow,
    responsive: [
        {
            breakpoint: 1350,
            settings: {
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 501,
            settings: {
                slidesToShow: 1,
            }
        },
    ]
} );
